const scheme = 'wadouri';
const base = 'http://localhost:8080/static';
const seriesNumber = 'lizongjie';
// const seriesNumber = 0;

export default function(imageId){
    // return `${scheme}:${base}/${seriesNumber}/${imageId}`
    return `${imageId}`
}